module.exports = __webpack_public_path__ + "static/common-stocks-and-uncommon-profits-65030319df59cccf759993b02a657c59.jpg";